import React from "react";
import LoginForm from "./LoginForm";
import "./LoginV2.css";

export default function LoginV2() {
  return (
    <div className="LoginV2">
      <LoginForm />
    </div>
  );
}
